import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface MigrationNoticeModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-migration-notice-modal',
  templateUrl: './migration-notice-modal.component.html',
  styleUrls: ['./migration-notice-modal.component.css']
})
export class MigrationNoticeModalComponent extends DialogComponent<MigrationNoticeModalModel, boolean> implements OnInit {
  title: string;
  data: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    setTimeout(function () {
      document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
  }

  closeModal() {
    this.result = true;
    this.close();
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/migration-notice-modal.component.ts